import { type AdminCapability, type AdminRole, capabilitiesForRoles } from 'common/models/admin/rbac';

export interface AuthCapabilities {
  roles: AdminRole[];
  can: (capability: AdminCapability) => boolean;
}

/** Build the client-side capability checker from the roles returned by establishAdminSession. */
export function capabilitiesForSession(roles: AdminRole[]): AuthCapabilities {
  const caps = capabilitiesForRoles(roles);
  return { roles, can: (capability) => caps.has(capability) };
}
